import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ForwardPrayerModal = ({ title,show, handleClose, handleForward }) => {
  const [email, setEmail] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [message, setMessage] = useState("");
  // Detect screen size for mobile optimization
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 576);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      fullscreen={isMobile} // Fullscreen on small screens
    >
      <Modal.Header closeButton className="modal-header bg-dark text-light">
        <Modal.Title className="modal-title">📩 Forward Prayer Request {" " +title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-light">
        <p>🙏 Please enter the recipient's email address:</p>
        <Form>
          <Form.Group>
            <Form.Control
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ fontSize: "1.2rem", padding: "10px" }} // Touch-friendly
            />
          </Form.Group>
          <Form.Group className="mt-3">
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ fontSize: "1.2rem", padding: "10px" }} // Touch-friendly
          />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="secondary" onClick={() => { setEmail(""); handleClose(); }} style={{ fontSize: "1rem" }}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleForward(email,message);
            handleClose();
          }}
          disabled={!email.trim()}
          style={{ fontSize: "1rem" }}
        >
          Forward
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForwardPrayerModal;
